import {
  CubeDimensionEnum,
  CubeMeasureEnum,
} from '../../services/data/impl/cube/cubeSlice';
import { CustomerSummary } from './hooks/useCustomerSummaryQuery';

/**
 * Type guard function to check if a given key is a valid key of the CustomerSummary type.
 *
 * @param key - The string key to check.
 * @returns A boolean value that is `true` if the key exists in the CustomerSummary type, otherwise `false`.
 */
export const isKeyOfCustomerSummary = (
  key: string
): key is keyof CustomerSummary => {
  // Create a mock object based on the CustomerSummary type.
  const mockCustomerSummary: CustomerSummary = {
    [CubeMeasureEnum.detectionFactAvgCountPerMeter]: 0,
    [CubeMeasureEnum.DetectionFactAvgLength]: null,
    [CubeMeasureEnum.DetectionFactHasColorHSV]: null,
    [CubeDimensionEnum.detectionFactRanchId]: 'someString',
    [CubeDimensionEnum.ranchName]: 'someString',
    [CubeDimensionEnum.detectionFactBlockId]: 'someString',
    [CubeDimensionEnum.blockName]: 'someString',
    [CubeDimensionEnum.detectionFactScanId]: 'someString',
    [CubeDimensionEnum.scanDate]: 'someString',
    [CubeDimensionEnum.className]: 'someString',
    [CubeDimensionEnum.modelName]: 'someString',
    [CubeDimensionEnum.modelVersion]: 'someString',
  };

  return key in mockCustomerSummary;
};

import _ from 'lodash';

/**
 * Adds an object to an array if an equivalent object does not already exist.
 * @param {any[]} array - The array to add the object to.
 * @param {any} obj - The object to add.
 * @returns {boolean} True if the object was added, false if it was a duplicate.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function addIfUnique(array: any[], obj: any): boolean {
  const index = array.findIndex((item) => _.isEqual(item, obj));
  if (index === -1) {
    array.push(obj);
    return true;
  }
  return false;
}
